import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { DatePipe } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
declare var getHexAscii: any;
@Component({
  selector: 'app-positivepay',
  templateUrl: './positivepay.component.html',
  styleUrls: ['./positivepay.component.css']
})
export class PositivepayComponent implements OnInit {

     regsplchar = /[-!$%^&*()+|~=`{}[:;<>?@#\]]/g;



  isShow: string='show';
  scoAccounts: any;
  chequeNo: number;
  chequeNoError: string;
  chequeType: string;
  chequeTypeError: string;
  payeeName: string;
  payeeNameError: string;
  payeeAccount: string;
  payeeAccountError: string;
  amountError: string;

  chequeDate:any;
  currDate:any;
  acctNo: string;
  acctNoError: string;
  currDateError: string;
  chequeDateError: string;
  userName: any;
  custNo: string;
  isShow1: string;
  showOtpInput: string='no';
  otpError: string;
  amount: number;
  otp: number;
  readonlyflag: boolean;
  errorMsg: string;
  errorFromBackend: string;
  sucessMsg: string;
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate();
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentDateFormatted: string;
  private _jsonURL = 'assets/SampleUrl.json';
  ppsMinAmount: any;
 
  

  myDatePickerOptions1: IMyDpOptions = {
    inline: false,
    dateFormat: 'dd-mmm-yyyy',
    editableDateField:false,
    openSelectorTopOfInput:true,
    // disableUntil:{year: this.disbYear, month: this.disbMonth, day: this.currentDate},
    disableUntil:{year: this.currentYear, month: this.currentMonth-3, day: this.currentDate},
};
 
  disbMonth: number;
  disbYear: number;
  currentDateLast3: string;
  minDate1: string;
  bankName1: any;
  bankNameOnDashboard: any;
  // disbYear: number;
  fromMonth: number;
 

  constructor( private webService: CallBackEndService,
    private spinnerService: Ng4LoadingSpinnerService,
    private http: HttpClient,
    private router : Router) {
      this.getJSON().subscribe(data => {
        console.log(' Sample Json Obj: '+JSON.stringify(data));
        this.ppsMinAmount = Number(data.ppsMinAmount);
        console.log('pps min Amt is ------'+this.ppsMinAmount);
        if(this.ppsMinAmount==='NaN'){
          // alert('error reading Min Amount from json');
          this.router.navigate[("/dashboard")];
        }
        //this.disbMonth=
        // if(this.disbMonth-3<0){
        //   this.disbYear=this.disbYear-1;
        // }
       
       
       // console.log('urlfromJson----:-'+this.urlfromJson);
       });

    this.showOtpInput='no';
    this.readonlyflag=false;
    this.scoAccounts=JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.userName=sessionStorage.getItem('storedUserName');
    this.custNo=sessionStorage.getItem('custNo'); 
    this.currentDateFormatted=this.currentDate+'-'+this.currentMonth+'-'+this.currentYear;
    console.log('date is: '+this.currentDateFormatted);

    // code from pps apk for date disable start
       
      
    // pps apk code end
   }
   public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }
  ngOnInit() {
  }

  validateChequeNo(){

    // if(this.chequeNo==='' || this.chequeNo==undefined || this.chequeNo==null){
    //     this.chequeNoError='yes';
    //     return false;
    // }else{
    //   this.chequeNoError='';
    //     return true;
    // }

    if ( this.chequeNo === undefined || this.chequeNo === null ) {
      this.chequeNoError = 'required';
      return false;
    } else if (this.chequeNo==0 ) {
      this.chequeNoError = 'zero';
      return false;
    }else if(this.chequeNo.toString().indexOf(".")>-1){
      this.chequeNoError = 'hasDot';
      return false;
    } else if (this.chequeNo.toString().length>6 ){
      this.chequeNoError = 'lengthError';
      return false;
    } else{
        this.chequeNoError='';
           return true;
       }
  }
  changeValidateChequeNo(){
    this.chequeNoError='';
  }

  validateChequeType(){
    if(this.chequeType==='' || this.chequeType==undefined || this.chequeType==null){
      this.chequeTypeError='yes';
      return false;
  }else{
    this.chequeTypeError='';
      return true;
  }
  
  }
  changeValidateChequeType(){
    this.chequeTypeError='';
  }
  validatePayeeName(){
  //   if(this.payeeName==='' || this.payeeName==undefined || this.payeeName==null){
  //     this.payeeNameError='yes';
  //     return false;
  // }else{
  //   this.payeeNameError='';
  //     return true;
  // }

  if (this.payeeName === undefined || this.payeeName === null || this.payeeName === '' || this.payeeName === ' '  ) {
    this.payeeNameError = 'required';
    return false;
  }
   else if (this.payeeName.match(this.regsplchar)) {
    this.payeeNameError = 'splChar';
    return false;
  } else{
    this.payeeNameError='';
      return true;
  }

  }
  changeValidatePayeeName(){
    this.payeeNameError='';
  }
  validatePayeeAccount(){
    if(this.payeeAccount==='' || this.payeeAccount==undefined || this.payeeAccount==null){
      this.payeeAccountError='yes';
      return false;
  }else{
    this.payeeAccountError='';
      return true;
  }
  }

  changeValidatePayeeAccount(){
    this.payeeAccountError='';
  }

  validateAmount(){
    // console.log('amount is : '+this.amount+'this.ppsMinAmount '+this.ppsMinAmount);
    //  if (this.amount === undefined || this.amount === null || this.amount<1 ) {
    //   this.amountError = 'yes';
    //   return false;
    // } else if (this.amount<this.ppsMinAmount ) {
    //   this.amountError = 'lessthan50k';
    //   return false;
    // }
    // else if(this.amount.toString().indexOf(".")>-1){
    //   this.amountError = 'hasDot';
    //   return false;
    // } else if ( this.amount.toString().length>13 ) {
    //   this.amountError = 'lengthError';
    //   return false;
    // } 
    if (this.amount === undefined || this.amount === null ) {
      this.amountError = 'required';
      return false;
    } else if ( this.amount<1 ) {
      this.amountError = 'invalidAmount';
      return false;
    } else if(this.amount.toString().indexOf(".")>11){
      this.amountError = 'hasDot';
      return false;
    } else if ( this.amount<this.ppsMinAmount ) {
      this.amountError = 'lessthan50k';
      return false;
    }else if ( this.amount.toString().indexOf(".")>-1 && this.amount.toString().length>14 ) {
      this.amountError = 'lengthError';
      return false;
    }else if ( (!(this.amount.toString().indexOf(".")>-1)) && this.amount.toString().length>11 ) {
      this.amountError = 'lengthError';
      return false;
    }else if((this.amount.toString().indexOf(".")>-1) && (this.amount.toString().length-this.amount.toString().indexOf(".")>3)){
      this.amountError = 'moreThanTwoDecimal';
      return false;
    }else{
    this.amountError='';
      return true;
  }
  }
  changeValidateAmount(){
    this.amountError='';
  }

  validateCurrDate(){
    console.log('current date blrr called');
    if(this.currDate==undefined){
      this.currDateError='yes';
      return false;

    }else{
      this.currDateError='';
      return true;
    }
  }
  validateChequeDate(){
    console.log('cheque date blrr called');
    if(this.chequeDate==undefined){
      this.chequeDateError='yes';
      return false;

    }else{
      this.chequeDateError='';
      return true;
    }

  }
  changeValidateChequeDate(){
    this.chequeDateError='';

  }
  validateAcctNo(){
    console.log('selecteed acc is: '+this.acctNo);
    if(this.acctNo==='' || this.acctNo==undefined || this.acctNo==null){
      this.acctNoError='yes';
      console.log('selecteed acc is1: '+this.acctNo);
      return false;
    }else{
      this.acctNoError='';
      console.log('selecteed acc is2: '+this.acctNo);
      return true;
    }
  }
  changeValidateAcctNo(){ 
    this.acctNoError='';
  }

  getOtp(){
    if(this.validateAcctNo() && this.validateChequeNo() &&  this.validatePayeeName()
    && this.validateAmount() && this.validateChequeDate() ){
      //call generate otp webservice
      // let temp='temp';
      // if(temp==='temp'){
      //   this.showOtpInput='yes';
      //   this.readonlyflag=true;
      //   console.log('otp generated')
      //   return;
      // }
      this.isShow1='';
      this.spinnerService.show();
     let request:IbRequest= new IbRequest();
      request.param1 = getHexAscii("",this.userName),
        request.param2 =this.userName;

      /*request.param3 = this.chequeNo;
      request.param4 = this.custNo;
      request.param5 = this.narration;
       const user: any = {
          'userName': this.userName,
    };
    request.param6=user;*/
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        if(data.status!=null && data.status==='S200'){
         // this.isShow='showOtpPage';
          this.showOtpInput='yes';
          this.readonlyflag=true;


        }else{
          //this.showOtpInput='no';
          this.isShow1='showError';
        }
      });
        


    }
  }

  validateOtp(){
    if(this.otp===undefined || this.otp===null){
      this.otpError='yes';
      return false;
    }else if(this.otp==0 || this.otp.toString().length!=6 ){
      this.otpError='lengthErr';
      return false;
    }else if(this.otp.toString().indexOf(".")>-1){
      this.otpError='lengthErr';
      return false;    }
    else{
      this.otpError='';
      return true;
    }
  }
  changeValidateOtp(){
    this.otpError='';
  }
  
  positivePaySubmit(){
    if(this.validateAcctNo() && this.validateChequeNo() &&  this.validatePayeeName()
    &&  this.validateAmount() && this.validateChequeDate() && 
      this.validateOtp()){
      console.log('validtae otp and call WS');
      this.spinnerService.show();
      
      var chequeDate1 = (this.chequeDate.date.day + "-" +(this.chequeDate.date.month) + "-" + this.chequeDate.date.year);
      // var currDate1 = (this.currDate.date.day + "-" +(this.currDate.date.month) + "-" + this.currDate.date.year);
      // console.log('dates: '+chequeDate1+' '+currDate1 );
      const request:IbRequest=new IbRequest();
      let positivePayDetails ={
        "Account": this.acctNo,
        "ChequeNo": this.chequeNo,
        "ChequeType": this.chequeType,
        "ChequeDate": chequeDate1,
        "PayeeName": this.payeeName,
        "PayeeAccount": this.payeeAccount,
        // "Date": currDate1,
        "Date": this.currentDateFormatted,
        "Amount": this.amount+'',
        "CustNo": this.custNo,
        "Source": "OnePageIB"
      }
      request.param2=getHexAscii("",this.otp)+'';
      request.param3=this.userName;
      request.param6=positivePayDetails;
      this.webService.getResponse(request, 'positivePaySubmit').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        this.otp=undefined;
        if(data.status!=null && data.status==='S200'){
          this.isShow='sucess';
          this.sucessMsg=data.param1;
        }
        else if(data.status!=null && (data.status==='S333' || data.status==='S334')){
           this.otpError='errorFromService';
           this.errorMsg=data.param1;
        }
        else if(data.status!=null && data.status!=='S200'){
          // this.errorFromBackend='yes';
          // this.errorMsg=data.param1;
          this.isShow='error';
          this.sucessMsg=data.param1;
        }else{
         // this.errorFromBackend='yes';
          this.isShow='error';
          //this.sucessMsg=data.param1;

          this.sucessMsg=(data.param1==null) ? 'Something went wrong' : data.param1;
        }
        // else  if(data.status!=null && data.status==='S334'){

        // }
      });


    }
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/positivepay/positivepay.component.ts